import React from 'react';
import { Box } from '@mui/material';
import { FaChild, FaVenusMars, FaCity, FaUser } from 'react-icons/fa';
import Services from '../Common/Services/page';
import { QUERY_KEYS_SIA } from '../../Common/hooks/useChartsData';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import { CityServicesWrapper } from '../../Common/Services/pages/CityServices';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Faixa Etária',
        path: '/governanceroom/dashboardsiasus/perfil/agegroup',
        icon: <FaChild style={{ marginRight: '5px' }} />
    },
    {
        title: 'Gênero',
        path: '/governanceroom/dashboardsiasus/perfil/gender',
        icon: <FaVenusMars style={{ marginRight: '5px' }} />
    },
    {
        title: 'Raça/Cor',
        path: '/governanceroom/dashboardsiasus/perfil/ethnicity',
        icon: <FaUser style={{ marginRight: '5px' }} />
    },
    {
        title: 'Município',
        path: '/governanceroom/dashboardsiasus/perfil/city',
        icon: <FaCity style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardsiasus/perfil/agegroup':
        'Faixa Etária',
    '/governanceroom/dashboardsiasus/perfil/gender': 'Gênero',
    '/governanceroom/dashboardsiasus/perfil/ethnicity':
        'Raça/Cor',
    '/governanceroom/dashboardsiasus/perfil/city': 'Município'
};

const Perfil = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsiasus');
    };

    return (
        <Box>
            {/* Cabeçalho */}
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="agegroup"
                            element={
                                <Services
                                    module={{
                                        sectionTitle: 'do Total de Atendimentos'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIA.AGE_GROUP,
                                        url: 'governanceroom/dashboard/services/profile/age'
                                    }}
                                />
                            }
                        />
                        <Route
                            path="gender"
                            element={
                                <Services
                                    module={{
                                        sectionTitle: 'do Total de Atendimentos'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIA.GENDER,
                                        url: 'governanceroom/dashboard/services/profile/gender'
                                    }}
                                />
                            }
                        />
                        <Route
                            path="ethnicity"
                            element={
                                <Services
                                    module={{
                                        sectionTitle: 'do Total de Atendimentos'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIA.RACE_COLOR,
                                        url: 'governanceroom/dashboard/services/profile/ethnicity'
                                    }}
                                />
                            }
                        />
                        <Route
                            path="city"
                            element={
                                <CityServicesWrapper
                                    queryConfig={{
                                        key: QUERY_KEYS_SIA.CITY,
                                        url: 'governanceroom/dashboard/services/profile/residence'
                                    }}
                                />
                            }
                        />
                        <Route
                            path="/"
                            element={<Navigate to="agegroup" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Perfil;
